export default __webpack_public_path__ + "static/media/035-sink.4bb1f504.svg";